import { StoredItem } from "LibMargoWorld/item";

import { reloadWithPostData } from "./util";

function removeItem(itemIDs: number[], toRemove: number) {
    const ind = itemIDs.indexOf(toRemove);
    itemIDs.splice(ind, 1);

    reloadWithPostData({
        type: "item",
        items: itemIDs.join(","),
    });
}

function makeButton(label: string, code: string, target: HTMLTextAreaElement) {
    const $btt = document.createElement("button");
    $btt.innerText = label;
    $btt.addEventListener("click", () => {
        target.innerHTML += code + "\n";
    });
    return $btt;
}

const questRewardString = `## Nagroda z questa

Przedmiot jest nagrodą za ukończenie questa: **QUESTNAME**.`;

export function initConditionalUpdaterHelper() {
    const items = <NodeListOf<HTMLElement>>document.querySelectorAll(".margonem_item");
    const itemIDs: number[] = [];
    for (const it of items) {
        const item: StoredItem = JSON.parse(it.getAttribute("data-itemtip"));
        itemIDs.push(item.id);
        it.addEventListener("contextmenu", (e) => {
            if (e.ctrlKey) {
                reloadWithPostData(
                    {
                        type: "item",
                        items: `${item.id}`,
                    },
                    true,
                );
            } else {
                removeItem(itemIDs, item.id);
            }
            e.preventDefault();
        });
    }

    // Add helper buttons
    const $form = document.querySelector("form");
    const $buttonWrapper = document.createElement("div");
    $form.parentElement.insertBefore($buttonWrapper, $form);

    const $textarea = $form.querySelector("textarea");
    $buttonWrapper.appendChild(makeButton("Tag", `async (item, helper) => await helper.addTag(item, "TAGID")`, $textarea));
    $buttonWrapper.appendChild(
        makeButton("Loot", `async (item, helper) => {const loot = item.loot ?? []; loot.push("PSEUDOCLASS"); item.loot = loot;}`, $textarea),
    );
    $buttonWrapper.appendChild(
        makeButton(
            "Quest-reward",
            `async (item, helper) => {\n\tawait helper.addTag(item, "quest-reward");\n\titem.notes = \`${questRewardString}\`\n}`,
            $textarea,
        ),
    );
    $buttonWrapper.appendChild(makeButton("Removed", `async (item, helper) => {\n\tawait helper.addTag(item, "removed");\n}`, $textarea));
    $buttonWrapper.appendChild(
        makeButton(
            "Event-other",
            `async (item, helper) => {\n\tawait helper.addTag(item, "event-other");\n\tawait helper.addTag(item, "event");\n}`,
            $textarea,
        ),
    );
    $buttonWrapper.appendChild(
        makeButton("MargoMini", `async (item, helper) => {\n\tawait helper.addTag(item, "removed");\n\tawait helper.addTag(item, "margomini");\n}`, $textarea),
    );
}
